<div class="login-container container-fluid p-0">
    <div class="row m-0 h-100">

        <div class="img-container col-md-6 d-none d-md-flex align-items-center justify-content-center">
            <img src="assets/images/TuPiscinero-logo.png" class="logo-desktop">
        </div>

        <div class="content col-12 col-md-6 d-flex align-items-center justify-content-center">
            <div class="login-box">

                <div class="text-start mb-4">
                    <b class="welcome-text">¡Hola!</b>
                    <p class="instruction-text">Ingresa a tu cuenta para comenzar</p>
                </div>

                <div class="w-100">
                    <button mat-mdc-raised-button color="primary" class="login-button" (click)="login()">
                        <span>Ingresar a tu cuenta</span>
                    </button>
                </div>

            </div>
        </div>

    </div>
</div>